// Shown under the legal links. Keep in step with package.json "version":
// appVersion.test.ts fails when they drift, so a bump can't be half-done.
// (A direct `import { version } from package.json` does not compile under CRA's
// webpack, and importing the default would ship the whole dependency list.)
export const APP_VERSION = '0.1.0';
